import { GlobalState } from 'ha/types/store';

export const getListings = (state: GlobalState) => state.search.listings;

export const getIsSearchEmpty = (state: GlobalState) =>
  state.search.listings.length === 0;
